import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {
    addNewCompany, confirmEmailSetInitialValues,
    fetchNewCompany, manualTokenRefresh,
    showAuthLoader, userSignOut
} from "../actions";
import { showBBNotification} from "../util/bbHelpers";
import {INFO} from "../constants/ActionTypes";
import IntlMessages from "../util/IntlMessages";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {HashLink as Link} from "react-router-hash-link";
import pjson from "../../package.json";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Col, Row} from "reactstrap";
import {Link as MuiLink} from "@material-ui/core";

const ConfirmNewEntityForNewUserForm=(props)=>{
    const dispatch = useDispatch();
    const {didJustRegisterCompany, didJustRegisterUser, didJustVerifyForMFA} = useSelector(({auth}) => auth.appMisc)
    const {token, authUser, loader, entityToConfirm, errorWithEntityToConfirm,
        errorMessage, refreshToken, mfaSessionToken, loadingFetchNewCompany,
        loadingAddNewCompany, loadingManualTokenRefresh, errorLoadingAddNewCustomer} = useSelector(({auth}) => auth);

    const unableToRegister = (entityToConfirm && !entityToConfirm.can_register)
        || (authUser && authUser.user && !authUser.user.is_activated)
        || (authUser && authUser.security && !authUser.security.mfa_enabled)
        || errorLoadingAddNewCustomer;

    const mfaNotEnable = authUser && authUser.security && !authUser.security.mfa_enabled;
    const company = !unableToRegister && entityToConfirm && entityToConfirm.entity;

    // console.log("entityToConfirm", entityToConfirm, "authUser.user", authUser.user, "authUser Security" ,authUser.security)
    // const company = testDataNewCompany.entity;

    const companyLocation = company
    && company.location_city
    && company.location_state
    && company.location_country
        ? `${company.location_city}, ${company.location_state}, ${company.location_country}`
        : null;

    //variables grabbed form the URL parameters
    const {match, location} = props;

    //form validation
    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        dispatch(showAuthLoader());
        dispatch(addNewCompany(company.id))
    }

    const handleLogout = () => {
        console.log("Logging out from confirm company page.");

        dispatch(userSignOut());
    }

    const emailVerified = authUser && authUser.user && authUser.user.is_activated;

    const localToken = JSON.parse(localStorage.getItem('token'));

    // useEffect(()=>{
    //     // console.log("Tokens updated---refreshToken is", bbShortenString(refreshToken, 40, true), "and current token is", bbShortenString(token,40,true), "mfaSessionToken is", bbShortenString(mfaSessionToken,40,true),);
    //     // if(localToken !== token && !entityToConfirm){
    //     //     window.location.reload();
    //     // }
    // }, [token, refreshToken, mfaSessionToken, localToken])
    // console.log("errorMessage", errorMessage, "company", company, "company.name", company.name, "companyLocation", companyLocation)

    useEffect(()=>{
        console.log("UseEffect for dispatching manualTokenRefresh, errowithEntityTOConfirm is", errorWithEntityToConfirm, "mfaNotEnabled is",mfaNotEnable, "& emailVerfieid is", emailVerified)
        if(errorWithEntityToConfirm && !mfaNotEnable && emailVerified){
            console.log("Manual token refresh evaluated as needing to be called.")
            dispatch(manualTokenRefresh());
        }
    },[errorWithEntityToConfirm, mfaNotEnable, emailVerified])

    useEffect(()=>{
        console.log("useEffect was called to evaluate if entityTOConfirm is set, localtoken", localToken, "token", token, "refreshToken", refreshToken)
        if(!entityToConfirm){
            console.log("fetch new company being called-- token in state is--", token, "localtoken is", localToken)
            dispatch(fetchNewCompany())
        } else{
            console.log("This useeffect looking at fetchNewCompany was called, api request was not triggered. entityToConfirm has a value", "local token", localToken )
        }
    }, [entityToConfirm, token, refreshToken, localToken])

    useEffect(() => {
        if (authUser && !authUser.user.is_approved) {
            showBBNotification(INFO,
                <IntlMessages id={"event.userInactive.title"}/>,
                <IntlMessages id={"event.userInactive.detail"}/>,
                true);
        }
    }, [authUser])

    useEffect(()=>{
        //if the confirm code didn't work, it will be set to false
        if (didJustRegisterCompany != null && didJustRegisterCompany === false){
            showBBNotification(INFO,
                <IntlMessages id={"event.companyRegistrationFailed.title"}/>,
                <IntlMessages id={"companyRegistrationFailed.detail"}/>,
                false);
        }

    }, [dispatch, didJustRegisterCompany, didJustVerifyForMFA, token, refreshToken, mfaSessionToken, emailVerified]);

    useEffect(()=>{
        //if the confirm code state has been set to success, redirect to login page
        if (didJustRegisterCompany) {
            dispatch(confirmEmailSetInitialValues()); //reset the state to default confirm email state
            props.history.push('/signin');
        }
    },[didJustRegisterCompany])

    return (
        <React.Fragment>
            <div
                className="app-login-container d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
                <div className="app-login-main-content">

                    {!errorWithEntityToConfirm
                        && !unableToRegister
                        && !errorLoadingAddNewCustomer
                        && company
                            ?
                        <div className="">
                            <Row className={"mx-2 mb-4 app-login-header"}>
                                <Col sm={3}>
                                    <a className="brand-logo-inner" href="https://www.breachbits.com" title={`${company.name && company.name}'s Logo`}>
                                        <img src={company.logo_url} alt={`${company.name && company.name}'s Logo`}/>
                                    </a>
                                </Col>
                                <Col className={"align-content-center align-self-center"}>
                                    <h1><IntlMessages id="appModule.confirm.company"/></h1>
                                    <h4><IntlMessages id="appModule.confirm.company.details"/></h4>
                                </Col>
                            </Row>

                            <hr/>


                        <div className="app-confirm-company m-2 p-2">
                            <form>
                                <fieldset>
                                    <Row>
                                        <Col sm={1} />
                                        <Col>
                                            <TextField
                                                // label={<p style={{color: "black"}}>{company.name}</p>}
                                                label={<IntlMessages id={"appModule.newClient.name"}/>}
                                                id="name"
                                                name="name"
                                                defaultValue={company.name ? company.name : "--"}
                                                margin="normal"
                                                className="mt-1 my-sm-3"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                fullWidth={true}
                                                // helperText={<IntlMessages id={"appModule.newClient.name"}/>}
                                            />
                                        </Col>
                                        <Col>
                                            <TextField
                                                // label={<p style={{color: "black"}}>{company.name}</p>}
                                                label={<IntlMessages id={"appModule.newClient.foundedYear"}/>}
                                                id="founded_year"
                                                defaultValue={company.founded_year ? company.founded_year : "--"}
                                                margin="normal"
                                                className="mt-1 my-sm-3"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                fullWidth={true}
                                                // helperText={<IntlMessages id={"appModule.newClient.name"}/>}
                                            />
                                        </Col>
                                        <Col sm={1} />
                                    </Row>

                                    <Row>
                                        <Col sm={1}/>
                                        <Col>
                                            <TextField
                                                // label={<p style={{color: "black"}}>{company.name}</p>}
                                                label={<IntlMessages id={"appModule.newClient.website"}/>}
                                                id="website"
                                                defaultValue={company.website ? company.website : "--"}
                                                margin="normal"
                                                className="mt-1 my-sm-3"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                fullWidth={true}
                                                // helperText={<IntlMessages id={"appModule.newClient.name"}/>}
                                            />
                                        </Col>
                                        <Col>
                                           <TextField
                                            // label={<p style={{color: "black"}}>{company.name}</p>}
                                            fullWidth={true}
                                            label={<IntlMessages id={"appModule.newClient.location"}/>}
                                            id="location"
                                            defaultValue={companyLocation ? companyLocation : "--"}
                                            margin="normal"
                                            className="mt-1 my-sm-3"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            // helperText={<IntlMessages id={"appModule.newClient.name"}/>}
                                        />
                                        </Col>
                                        <Col sm={1}/>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <hr/>
                                        </Col>
                                    </Row>

                                </fieldset>
                            </form>
                        </div>

                    </div>
                        :
                        <div className="">
                            <Row className={"mx-2 my-4 app-login-header"}>
                                <Col className={"align-self-center"}>
                                    <h1>Unable To Confirm Company Details</h1>
                                </Col>

                            </Row>
                            <Row style={{width: "100%"}}>
                                <Col>
                                    <hr style={{width: "100%"}}/>
                                </Col>
                            </Row>

                            <Row className={"m-2 p-2"}>
                                <Col>
                                    {errorMessage
                                    ? <h4>{errorMessage}</h4>
                                    : <h4>Error confirming company information. Please try again. If the error persists, contact <a href="mailto:support@breachbits.com" >support@breachbits.com</a></h4>}
                                </Col>
                            </Row>

                            <Row className={"m-2 p-2 text-center"}>
                                <Col>
                                    <span className="text-primary jr-link">
                                                    <MuiLink href={"mailto:support@breachbits.com?subject=BreachBits Support Request"}>
                                                        <Button variant={"contained"}>Email support@breachbits.com
                                                        </Button>
                                                    </MuiLink>
                                                </span>
                                </Col>
                            </Row>



                            <Row className={"m-2 p-2"}>
                                <Col>
                                    {entityToConfirm && entityToConfirm.can_register && mfaNotEnable
                                    && <h4>You must have <Link to={"/addMFA"}>MFA enabled</Link> to register your company.</h4> }
                                </Col>
                            </Row>
                        </div>

                    }
                    <Row className={"text-right mx-1 px-1"} style={{width: "100%"}}>
                        <Col className={"align-self-center text-left"}>
                            {token && //If user is logged in, they need to logout, no access to dashboard
                            <Link to="/signin" onClick={handleLogout} className={""}>
                                <IntlMessages id="form.goSignIn"/>
                            </Link>
                            }
                            {!token && //If user is not logged in, they can go back to the signin.
                            <Link to="/signin" className={""}>
                                <IntlMessages id="form.goSignIn"/>
                            </Link>
                            }
                        </Col>
                        <Col className={"text-right align-self-center"}>
                            {/*TODO: can only register if 2fa is set up, user's email is verified*/}
                            {!errorWithEntityToConfirm
                                && company
                                &&
                            <Button className={""}
                                onClick={handleSubmit(onSubmit)}
                                disabled={unableToRegister }
                                variant="contained" color="primary">
                            <IntlMessages id="appModule.register"/>
                        </Button>}
                            {authUser && authUser.security && !authUser.security.mfa_enabled
                            && <p><small>You must have <Link to={"/addMFA"}>MFA enabled</Link> to register your company.</small></p>
                            }
                    </Col>

                    </Row>

                    <div id={"version"} className={"text-right mt-3"} style={{width: "100%"}}> v. {`${pjson.version}`}</div>



                </div>


                {   (loadingFetchNewCompany || loadingAddNewCompany
                    || loader || loadingManualTokenRefresh) &&
                    <div className="loader-view">
                        <CircularProgress/>
                    </div>
                }

            </div>
            <div className="break"> </div>

        </React.Fragment>
    );

}

export default ConfirmNewEntityForNewUserForm;